<template>
  <div class="maindiv snotice-wrap">
    <div class="ht200 sindex-bg"></div>
    <div class="bar-menu2 wd1200 tcenter fs0 pb40 pt30">
      <left></left>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Left from "../../components/practice/Left";
export default {
  name: "practiceGoArticle",
  components:{
    Left
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/practice/goArticle.vue